import React, { useEffect, useState } from 'react'
import styles from "./image.module.css"
import { MdOutlineImage } from 'react-icons/md'
import MediaUnavailable from '../MediaUnavailable'

const Image = ({ url, width, height, showPreview, quotedMessage = false, openPreview = () => { } }) => {
    const [failed, setFailed] = useState(false)
    const style = showPreview ? { minWidth: width > 0 && width < 350 ? `${width}px` : "350px", minHeight: height > 0 && height < 350 ? `${height}px` : "300px" } : {}

    useEffect(() => setFailed(false), [url])

    if (failed) {
        return <MediaUnavailable type="image" compact={quotedMessage} onRetry={() => setFailed(false)} />
    }

    return (
        url ?
            <div className={`${styles.container} ${quotedMessage ? styles.quoted : ''}`} onClick={() => openPreview(showPreview)}>
                <img
                    src={url}
                    alt="Imagem"
                    loading="lazy"
                    style={style}
                    onError={() => setFailed(true)}
                />
            </div>
            :
            <div className={`${styles.container} ${quotedMessage ? styles.quoted : ''}`}>
                <MdOutlineImage style={style} />
            </div>
    )
}

export default Image
